module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.0e7d7c43.svg";